<template>
  <v-container>
    <v-sheet class="pa-8 mb-12">
      <div class="d-flex align-center title-container">
        <div class="title mr-4">{{ sheetName }}</div>
        <v-btn
          depressed
          rounded
          class="edit-btn justify-start textcolor--text"
          style="border-width: 1 !important; border-color: #e3e3e3 !important; border-style: solid !important; margin-right: 10px;"
          height="26"
          color="white"
          @click="editSheet"
        >{{$t('album.edit')}}</v-btn>
        <v-btn
          depressed
          rounded
          height="26"
          color="errorlight"
          class="errorstrong--text"
          @click="deleteSheet"
        >{{$t('album.delete')}}</v-btn>

        <div class="ml-auto align-end">{{ $t('album.create_at')}} {{ formatedTime(sheet.ctime) }}</div>
      </div>
      <v-divider></v-divider>
      <div class="d-flex mt-6 mb-6">
        <div class="d-flex flex-column mr-12">
          <div class="mb-2">{{ $t('album.sheet.text.score_number', [this.scores.length]) }}</div>

          <div
            class="belong-album"
          >{{$t('album.sheet.album')}}: {{ albumName }} ({{getScope(this.album.scope)}})</div>
        </div>
        <div class="d-flex flex-column ml-12">
          <div v-if="this.album.scope === 'public'" class="d-flex">
            <span>{{$t('album.sheet_state.review_state')}}:</span>
            <span>{{ reviewState }}</span>
            <div
              class="underline ml-2 errorstrong--text"
              @click="gotoReviewDetail"
            >{{$t('album.check')}}</div>
          </div>
        </div>

        <div class="d-flex flex-column ml-auto align-end">
          <div>
            <span class="mb-2 textcolor--text">{{$t('album.sheet.music_score_state')}}:</span>
            <span>{{ releaseState }}</span>
          </div>
          <div @click="changeState" class="underline">{{$t('album.change_state')}}</div>
          <!-- <v-btn depressed color="primary" rounded class="white--text" @click="changeState">{{$t('album.change_state')}}</!-->
        </div>
      </div>
      <div class="d-flex">
        <v-btn
          rounded
          depressed
          width="178"
          color="primary"
          @click="addScore"
        >{{$t('album.sheet.add_score')}}</v-btn>
      </div>

      <v-simple-table fixed-header class="mt-8" v-if="!loading">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="tablegray text-left"></th>
              <th class="tablegray text-left">{{$t('album.sheet.instrument.instrument_type')}}</th>
              <th class="tablegray text-left">{{$t('album.sheet.composer')}}</th>
              <th class="tablegray text-left">{{$t('albums.table.ctime')}}</th>
              <th class="tablegray text-left"></th>
            </tr>
          </thead>
          <tbody>
            <!-- {mbackgroundcolor: index%2 !== 0} -->
            <tr
              :class="{tablegray:  index%2 !== 0}"
              v-for="(score, index) in scores"
              :key="score.fullName"
            >
              <td>
                <v-chip
                  width="10"
                  :class="[score.ctype == 'accompaniment' ? 'primary' : 'black', 'white--text']"
                  small
                >{{ score.ctype == 'accompaniment'? $t('upload_sheet.acc') : score.sequence + 1}}</v-chip>
              </td>
              <td>{{ getInstrument(score.score_data.instrument) }}</td>
              <td>{{ getComposer(score) }}</td>
              <td>{{ formatedTime(score.score_data.ctime) }}</td>
              <td
                class="preview primary--text"
                @click="previewSheetShow(score)"
              >{{$t('upload_sheet.preview')}}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>
    <v-dialog v-model="sheetDialog">
      <template v-slot:activator="{ on }"></template>
      <v-card class="white pa-4">
        <div class="d-flex">
          <v-btn class="ml-auto" icon width="20" height="20" dark @click="sheetDialog = false">
            <v-img :src="img.close"></v-img>
          </v-btn>
        </div>
        <div :ref="`sheetShow`" class="sheet-show" id="viewer"></div>
      </v-card>
    </v-dialog>

    <div class="d-flex flex-column justify-center" style="height: 300px" v-if="loading">
      <div class="d-flex justify-center">
        <v-progress-circular :size="70" :width="7" color="primary mt-12" indeterminate></v-progress-circular>
      </div>
    </div>
  </v-container>
</template>

<script>
import "../musicxml-vexflow.js";

export default {
  name: "SheetDetail",
  data: function() {
    console.log("sheet", this.$store.getters.currentSheet);
    return {
      loading: true,
      sheetDialog: false,
      album: this.$store.getters.currentAlbum,
      sheet: this.$store.getters.currentSheet,
      albums: [],
      scores: [],
      isZh: true,
      img: {
        close: require("../assets/img/close_img.svg")
      }
    };
    console.log("current sheet", this.$store.getters.currentSheet);
  },

  created: function() {
    this.getData();
  },
  mounted() {
    this.$store.commit("setCurrentScore", { score: null });
  },
  computed: {
    scope: function() {
      if (!this.album) return "";
      if (this.album.scope == "private") {
        return this.$t("album.share_state.personal");
      }

      if (this.album.scope == "public") {
        return this.$t("album.share_state.public");
      }

      if (this.album.scope == "organization") {
        return this.$t("album.share_state.organization");
      }
    },
    releaseState: function() {
      if (!this.sheet) return "";
      if (this.sheet.release_status == "online") {
        return this.$t("album.sheet_state.online");
      } else {
        return this.$t("album.sheet_state.offline");
      }
    },
    reviewState: function() {
      if (!this.sheet) return "";

      return this.commonUtils.getReviewStatus(
        this,
        this.sheet.review_status,
        this.album.scope == "public"
      );
    },
    albumName: function() {
      if (!this.album) return;

      return this.commonUtils.getDataWithLanguage(this, this.album, "name");
    },
    sheetName: function() {
      if (!this.sheet) return "";
      const currentLan = this.$i18n.locale;
      return this.commonUtils.getDataWithLanguage(this, this.sheet, "name");
    }
  },
  methods: {
    getData: async function() {
      this.isZh = this.$i18n.locale === "zh";
      const currentSheet = this.$store.getters.currentSheet;
      this.sheet = currentSheet;
      const userUuid = this.$store.getters.userUuid;
      if (userUuid) {
        //   this.commonUtils.getAlbumsByUuid(userUuid, this).then(response => {
        //     this.albums = this.albums.concat(response);
        //   });
        const albums = await this.commonUtils.getAlbumsByUuid(userUuid, this);
        this.albums = albums;
        this.loading = true;
        this.commonUtils
          .getAllTypeScoreOfSheet(currentSheet.uuid, this)
          .then(response => {
            this.loading = false;
            response = response.sort(
              (score1, score2) => score1.sequence - score2.sequence
            );
            for (const score of response) {
              const formatedScore = {
                uuid: score.uuid,
                ctype: score.ctype,
                musicxmlFile: {
                  file: null,
                  name: null
                },
                museScoreFile: {
                  file: null,
                  name: null
                },
                composer_data: score.composer_data,
                composer_uuid: score.composer_uuid,
                score_data: {
                  // fullName: score.data.name,
                  fullName: score.data.short_name,
                  fullName_en: score.data.name_en,
                  instrument: score.instrument,
                  ctime: score.ctime
                  // author:
                },
                files: score.data.files,
                exist_files: {
                  musicxmlFile: {
                    exist: score.data.files.xml.exist,
                    name: score.data.files.xml.name
                  },
                  museScoreFile: {
                    exist: score.data.files.muse_score.exist,
                    name: score.data.files.muse_score.name
                  }
                },
                sequence: score.sequence
              };
              this.scores.push(formatedScore);
            }
          });
      }
    },
    gotoReviewDetail: function() {
      this.$router.push({
        name: "sheet_review_detail"
      });
    },
    getComposer: function(score) {
      console.log("score------", score);

      if (score && score.composer_data && score.composer_data.data.name) {
        // return score.composer_data.data.name;
        return this.commonUtils.getDataWithLanguage(
          this,
          score.composer_data,
          "name"
        );
      } else {
        return "";
      }
    },
    formatedTime: function(timeString) {
      return this.commonUtils.convertTimeFormat(timeString);
    },
    selectScore: function(score, index) {
      this.commonUtils.toScoreDetail(this, score);
    },
    editSheet: function() {
      //   this.$router.push({
      //     name: "sheet_info_edit"
      //   });
      this.$store.commit("setRouteBackTo", {route_back_to: 'sheet_detail'});
      this.$store.commit("setRouteBackTo", {route_back_to: 'sheet_detail'});
      this.$router.push({
        name: "edit_sheet"
      });
      // this.$router.push({
      //     name: "sheet_info_edit",
      //     params: { id: album.uuid }
      // });
    },
    deleteSheet: function() {
      this.$confirm(
        this.$t("album.sheet.text.comfire_delete_sheet"),
        this.$t("global.text.dialog_notice"),
        {
          confirmButtonText: this.$t("global.text.btn_confirm"),
          cancelButtonText: this.$t("global.text.btn_cancel")
        }
      )
        .then(async () => {
          await this.commonUtils.deleteSheetByUuid(this.sheet.uuid, this);
          this.$store.commit("setCurrentSheet", { sheet: null });
          this.$router.push({ name: "album_detail" });
        })
        .catch(() => {});
    },
    addScore: function() {
      let maxSequence = 0;
      this.scores.forEach(score => {
        maxSequence =
          score.sequence > maxSequence ? score.sequence : maxSequence;
      });
      const sequence = maxSequence + 1;
      this.commonUtils.toAddScore(this, this.sheet, sequence);
    },
    changeState: async function() {
      if (!this.sheet) return;
      let result;
      if (this.sheet.release_status == "offline") {
        result = await this.commonUtils.releaseSheet(this.sheet.uuid, this);
        if (result.success) {
          this.sheet.release_status = "online";
        }
      } else {
        await this.$confirm(
          this.$t("album.sheet.text.offline_sheet_confirm"),
          this.$t("global.text.dialog_notice"),
          {
            confirmButtonText: this.$t("global.text.btn_confirm"),
            cancelButtonText: this.$t("global.text.btn_cancel")
          }
        ).then(async () => {
          result = await this.commonUtils.offlineSheet(this.sheet.uuid, this);
          if (result.success) {
            this.sheet.release_status = "offline";
          }
        });
      }
    },
    getScope(scope) {
      return this.$t("album.share_state." + scope);
    },
    getInstrument(instrument) {
      return this.commonUtils.getInstrument(this, instrument);
    },
    previewSheetShow(score, index) {
      console.log("previewSheetShow", score);
      this.sheetDialog = true;
      if (score.musicxmlFile && score.musicxmlFile.file) {
        this.commonUtils.readMusicXML(
          score.musicxmlFile.file,
          function(xml) {
            this.showSheetShow(this.$refs[`sheetShow`], xml);
          }.bind(this)
        );
      } else {
        if (
          score.exist_files &&
          score.exist_files.musicxmlFile &&
          score.exist_files.musicxmlFile.exist &&
          score.files &&
          score.files.xml &&
          score.files.xml.uuid
        ) {
          this.commonUtils.getMusicXMLFromUuid(
            this,
            score.files.xml.uuid,
            function(xml) {
              setTimeout(() => {
                this.showSheetShow(this.$refs[`sheetShow`], xml);
              }, 500);
            }.bind(this)
          );
        }
      }
    },
    showSheetShow(elem, xmlString) {
      console.log("SheetShowPreview mounted");
      if (!elem) return;
      //   const xmlString = //this.$store.getters.currentMusicXML;
      // setTimeout(() => {
      //   const sheetContent = this.$refs.sheetContent;
    window.MusicScoreView.maxHeight = null;
      elem.innerHTML = "";
      window.MusicScoreController.viewPortPadding = 100000;
      window.MusicScoreController.shareInstance.reset();
      window.MusicScoreController.shareInstance = new window.MusicScoreController(
        elem
      );
      window.MusicScoreController.shareInstance.loadDataWithXMLString({xmlStr: xmlString});
      console.log("SheetShowPreview mounted1");

      window.MusicScoreController.shareInstance.shallowTraversal();
      window.MusicScoreController.shareInstance.shallowTraversalToCheckDirection();
      window.MusicScoreController.shareInstance.deepTraversal();
      console.log("SheetShowPreview mounted2");
    }
  }
};
//"organization"
//"public"
//"private"
</script>

<style scoped>
.title-container {
  margin-bottom: 20px;
}
.title {
  font-size: 20px;
  /* font-family: SHBold; */
  font-weight: bold;
}

.edit-btn {
  border-width: 1 !important;
  border-color: #e3e3e3 !important;
  border-style: solid !important;
  margin-right: 10px;
  width: 40px;
  height: 26px;
}

.underline {
  text-decoration: underline;
  cursor: pointer;
}

.belong-album {
  /* font-family: SHRegular; */
  font-weight: normal;
}

.table-title {
  margin-top: 50px;
  font-size: 20px;
  /* font-family: SHRegular; */
  font-weight: normal;
}

div {
  color: #666666;
  font-size: 14px;
}

.preview {
  cursor: pointer;
}
</style>

